module.exports = __webpack_public_path__ + "static/media/the-promised-land-tablet.c3af2f26.jpg";